<template>
  <div class="min-h-screen p-8" style="background-color: var(--color-white)">
    <div class="flex flex-col items-center justify-center min-h-full">
      <!-- Main Container -->
      <div class="w-full max-w-lg p-8" style="border-radius: 10px; border: 1px solid var(--white-opacity-8); background: var(--white-opacity-3)">
        <div class="text-center">
          <!-- Not Supported Icon -->
          <div class="mb-6">
            <svg class="w-24 h-24 mx-auto text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z"
              ></path>
            </svg>
          </div>

          <!-- Error Message -->
          <h1 class="text-3xl text_color font-semibold mb-4">Not Supported</h1>
          <p class="secondary_color mb-8 leading-relaxed text-sm">
            Your current billing plan is on the legacy system and is not supported in this billing portal. Please contact support to migrate to the new billing system.
          </p>

          <!-- Action Buttons -->
          <div class="flex flex-col sm:flex-row gap-4 justify-center">
            <button @click="contactSupport" class="px-4 py-2 text-black text-sm font-medium bg-white rounded-md hover:bg-gray-200 transition font-semibold flex items-center justify-center gap-2">
              Contact Support
            </button>
            <button @click="goBack" class="px-4 py-2 text_color text-sm font-medium border border-gray-500 rounded-md hover:bg-gray-700 transition font-semibold">Go Back</button>
          </div>

          <!-- Contact Info -->
          <div class="mt-8 text-sm secondary_color">
            <p>Need help? Reach out to <a href="mailto:support@superagi.com" class="underline hover:text-white">support@superagi.com</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useRouter } from 'vue-router';

const router = useRouter();

const contactSupport = () => {
  window.location.href = 'mailto:support@superagi.com?subject=Legacy%20Billing%20Migration%20Request';
};

const goBack = () => {
  router.back();
};
</script>

<style scoped>
/* Additional styles if needed */
</style>
